module.exports = __webpack_public_path__ + "static/glean-laptop-3828becfaf9cd39b751d685cddd98bf0.png";